import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const Router = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_10962_94611)">
            <path
              d="M15.1359 0.0849609L15.5359 0.0849609L16.9988 12.0106H13.9368L15.1359 0.0849609Z"
              fill="url(#router_paint0_linear_10962_94611)"
            />
            <path
              d="M3.80849 0.134766L4.20849 0.134766L5.67136 11.9991H2.60938L3.80849 0.134766Z"
              fill="url(#router_paint1_linear_10962_94611)"
            />
            <path
              d="M0 13.999C0 12.8945 0.895431 11.999 2 11.999H18C19.1046 11.999 20 12.8945 20 13.999V17.999C20 19.1036 19.1046 19.999 18 19.999H2C0.895431 19.999 0 19.1036 0 17.999V13.999Z"
              fill="url(#router_paint2_linear_10962_94611)"
            />
            <rect
              x="1.86987"
              y="14.9189"
              width="16.1152"
              height="2.09961"
              rx="1.0498"
              fill="#8F8F8F"
            />
            <circle cx="3.00312" cy="15.9992" r="0.8" fill="#72F564" />
            <circle cx="5.40303" cy="15.9992" r="0.8" fill="#72F564" />
            <circle cx="16.8496" cy="15.9992" r="0.8" fill="#72F564" />
          </g>
          <defs>
            <linearGradient
              id="router_paint0_linear_10962_94611"
              x1="14.1393"
              y1="6.57864"
              x2="16.9988"
              y2="6.4634"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#676767" />
              <stop offset="0.463542" stop-color="#CECECE" />
              <stop offset="1" stop-color="#A7A7A7" />
            </linearGradient>
            <linearGradient
              id="router_paint1_linear_10962_94611"
              x1="2.81188"
              y1="6.59502"
              x2="5.67139"
              y2="6.47919"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#676767" />
              <stop offset="0.463542" stop-color="#CECECE" />
              <stop offset="1" stop-color="#A7A7A7" />
            </linearGradient>
            <linearGradient
              id="router_paint2_linear_10962_94611"
              x1="10"
              y1="11.999"
              x2="10"
              y2="20.1396"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#929292" />
              <stop offset="0.116681" stop-color="#A8A7A8" />
              <stop offset="0.867717" stop-color="#D8D8D8" />
              <stop offset="1" stop-color="#999499" />
            </linearGradient>
            <clipPath id="clip0_10962_94611">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </SVGIconRender>
  );
};

export default Router;
